import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d54dbea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-14 ant-col-xl-16" }, " Alteração em massa de Produtos "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-6 ant-col-xl-8" }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"float":"right"} })
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Concluir", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Cód. Interno:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Descrição:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Categoria:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Marca:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "NCM:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Origem:", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-bottom":"10px"}
}, null, -1))
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_categoria = _resolveComponent("selecionar-categoria")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_marca = _resolveComponent("selecionar-marca")!
  const _component_selecionar_tipo_produto = _resolveComponent("selecionar-tipo-produto")!
  const _component_selecionar_genero = _resolveComponent("selecionar-genero")!
  const _component_selecionar_ncm = _resolveComponent("selecionar-ncm")!
  const _component_selecionar_origem_mercadoria = _resolveComponent("selecionar-origem-mercadoria")!
  const _component_selecionar_cest = _resolveComponent("selecionar-cest")!
  const _component_selecionar_conceito_precificacao = _resolveComponent("selecionar-conceito-precificacao")!
  const _component_produto_custos = _resolveComponent("produto-custos")!
  const _component_produto_precos = _resolveComponent("produto-precos")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    style: {"z-index":"999"},
    width: 1200,
    centered: "",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile ? 'full-modal ss-modal-cadastros' : 'scroll-modal ss-modal-cadastros',
    maskClosable: false
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-lg ant-btn-secondary",
        style: {"color":"white","background-color":"dodgerblue"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmarAlteracao()))
      }, _hoisted_3)
    ]),
    default: _withCtx(() => [
      (_ctx.modalBase.computedVisivel)
        ? (_openBlock(), _createBlock(_component_a_skeleton, {
            key: 0,
            loading: _ctx.telaBase.carregando,
            paragraph: { rows: 15 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_card, {
                class: "ss-card-alinhado",
                titulo: "PRODUTOS ADICIONADOS PARA ALTERAÇÃO"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table, {
                    columns: _ctx.gradeBase.colunas.filter(c => c.visible),
                    "data-source": _ctx.state.dtoProduto,
                    rowKey: "codigoProduto",
                    pagination: { pageSize: 10, showSizeChanger: true },
                    loading: _ctx.telaBase.carregando,
                    scroll: _ctx.gradeBase.layoutMobile ? null : { x: (_ctx.gradeBase.windowWidth + 150), y: 280 },
                    size: "small"
                  }, {
                    bodyCell: _withCtx(({ column, record, text }) => [
                      (column.key === 'ProdutoMobile')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("span", null, [
                              _hoisted_5,
                              _createTextVNode(" " + _toDisplayString(record.codigoInterno), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _hoisted_6,
                              _createTextVNode(" " + _toDisplayString(record.descricao), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _hoisted_7,
                              _createTextVNode(" " + _toDisplayString(record.descricaoCategoria), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _hoisted_8,
                              _createTextVNode(" " + _toDisplayString(record.descricaoMarca), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _hoisted_9,
                              _createTextVNode(" " + _toDisplayString(record.ncm), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _hoisted_10,
                              _createTextVNode(" " + _toDisplayString(record.descricaoOrigem), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(text), 1))
                    ]),
                    emptyText: _withCtx(() => [
                      (_ctx.props.produtos.length <= 0)
                        ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                            key: 0,
                            mensagem: "Nenhum produto adicionado ainda"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source", "loading", "scroll"]),
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_component_card, {
                class: "ss-card-alinhado",
                titulo: "CAMPOS PARA ALTERAÇÃO"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form, { layout: "vertical" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria, {
                                codigoSelecionado: _ctx.state.codigoCategoria,
                                "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.codigoCategoria) = $event)),
                                empresas: [_ctx.props.empresa],
                                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.alterouCategoria = true))
                              }, null, 8, ["codigoSelecionado", "empresas"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_a_form_item, {
                            label: "Marca",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_marca, {
                                codigoSelecionado: _ctx.state.codigoMarca,
                                "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.codigoMarca) = $event)),
                                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.alterouMarca = true))
                              }, null, 8, ["codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipo Produto",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_tipo_produto, {
                                codigoSelecionado: _ctx.state.codigoTipoProduto,
                                "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.codigoTipoProduto) = $event)),
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.alterouTipoProduto = true))
                              }, null, 8, ["codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_a_form_item, {
                            label: "Gênero",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_genero, {
                                codigoSelecionado: _ctx.state.codigoGenero,
                                "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.codigoGenero) = $event)),
                                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.alterouGenero = true))
                              }, null, 8, ["codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_a_form_item, {
                            label: "NCM",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_ncm, {
                                codigoSelecionado: _ctx.state.codigoNcm,
                                "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.codigoNcm) = $event)),
                                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.alterouNcm = true))
                              }, null, 8, ["codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_a_form_item, {
                            label: "Origem",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_origem_mercadoria, {
                                codigoSelecionado: _ctx.state.codigoOrigem,
                                "onUpdate:codigoSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.codigoOrigem) = $event)),
                                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.alterouOrigem = true))
                              }, null, 8, ["codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_a_form_item, {
                            label: "CEST",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_cest, {
                                codigoSelecionado: _ctx.state.codigoCest,
                                "onUpdate:codigoSelecionado": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.codigoCest) = $event)),
                                onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.state.alterouCest = true))
                              }, null, 8, ["codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_a_form_item, {
                            label: "Precificação",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_conceito_precificacao, {
                                codigoSelecionado: _ctx.state.codigoPrecificacao,
                                "onUpdate:codigoSelecionado": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.codigoPrecificacao) = $event)),
                                onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.alterouPrecificacao = true))
                              }, null, 8, ["codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_produto_custos, {
                            carregando: _ctx.state.carregandoCustos,
                            tiposCustos: _ctx.state.tiposCustos,
                            custos: _ctx.state.custoProduto,
                            "onUpdate:custos": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.custoProduto) = $event))
                          }, null, 8, ["carregando", "tiposCustos", "custos"]),
                          _createVNode(_component_produto_precos, {
                            empresa: _ctx.props.empresa,
                            carregando: _ctx.state.carregandoPrecos,
                            tiposPrecos: _ctx.state.tiposPrecos,
                            custos: _ctx.state.custoProduto,
                            tabelasPrecos: _ctx.state.tabelasPrecos,
                            precos: _ctx.state.tabelaPreco,
                            "onUpdate:precos": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.tabelaPreco) = $event))
                          }, null, 8, ["empresa", "carregando", "tiposPrecos", "custos", "tabelasPrecos", "precos"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}